import { TranslationMessages } from '../types';
import { app } from './app/sv';
import { settingsApp } from './app/sv';

const sv: TranslationMessages = {
  nav: {
    howItWorks: 'Så fungerar det',
    why: 'Varför?',
    features: 'Funktioner',
    getStarted: 'KOM IGÅNG',
    dashboard: 'Dashboard',
    blog: 'Blogg',
  },
  hero: {
    title1: 'Telegram Stars',
    title2: 'Få betalt enkelt',
    subtitle: 'Skapa betalningslänkar direkt, hantera ditt saldo och ta ut till TON. 3 % plattformsavgift.',
    cta: 'Kom igång',
    hairsim: 'Simulera din hårtransplantation',
  },
  demo: {
    botName: 'Telegram Stars Bot',
    online: 'online',
    linkCreated: 'Betalningslänk skapad.',
    invoiceTitle: 'Premium Access',
    invoiceDesc: 'Månadsabonnemang',
    stars: 'Stars',
    payBtn: 'Betala 100 Stars',
    iPayNow: 'Jag betalar nu',
    paymentLabel: 'Telegram Stars-betalning',
    merchant: 'Handlare',
    amount: 'Belopp',
    confirmPay: 'Bekräfta betalning',
    paymentReceived: 'Betalning mottagen — 100 Stars',
    invoiceCredited: 'Invoice #xk9m2 · krediterat till saldo',
    thanks: 'Tack, åtkomst aktiverad',
    messagePlaceholder: 'Meddelande',
  },
  stats: {
    title: 'Betrodd av tusentals agenter',
    subtitle: 'Gå med i en växande community av handlare som använder Telegram Stars-betalningar',
    activeAgents: 'Aktiva agenter',
    transactions: 'Transaktioner',
    uptime: 'Drifttid',
    support: 'Support',
  },
  features: {
    title: 'Allt du behöver för att acceptera Telegram Stars-betalningar',
    subtitle: 'En komplett plattform för att hantera dina Telegram Stars-betalningar',
    instantTitle: 'Omedelbar skapelse',
    instantDesc: 'Bli agent på några sekunder. Ingen konfiguration krävs.',
    balanceTitle: 'Saldo hantering',
    balanceDesc: 'Följ dina intäkter i realtid med en intuitiv dashboard.',
    paymentsTitle: 'Telegram Stars-betalningar',
    paymentsDesc: 'Acceptera betalningar i Telegram Stars via din bot.',
    securityTitle: 'Maximal säkerhet',
    securityDesc: 'Oföränderlig ledger, säkra och transparenta transaktioner.',
    withdrawTitle: 'TON-uttag',
    withdrawDesc: 'Ta ut dina medel direkt till din TON-adress.',
    apiTitle: 'Robust API',
    apiDesc: 'Enkel integration med webhooks och ett komplett REST API.',
  },
  how: {
    title: 'Så fungerar det',
    subtitle: 'Kom igång i 3 enkla steg',
    startDemo: 'Starta demo',
    demoRunning: 'Demo körs...',
    reset: 'Återställ',
    step1Title: '1. Registrera dig',
    email: 'E-post',
    password: 'Lösenord',
    noCard: '✓ Inget kreditkort krävs',
    step2Title: '2. Skapa betalningslänkar',
    amountStars: 'Belopp (Stars)',
    generatedLink: 'Genererad länk:',
    shareLink: '✓ Dela denna länk med dina kunder',
    step3Title: '3. Ta ut dina medel',
    tonAddress: 'TON-adress',
    availableBalance: 'Tillgängligt saldo:',
    fee: 'Avgift: 3 %',
  },
  pricing: {
    title: 'Enkla och transparenta priser',
    subtitle: 'Inga dolda avgifter, inget åtagande',
    commission: 'Provision',
    perTransaction: 'per transaktion',
    freeAccount: 'Gratis kontoskapande',
    noMonthly: 'Inga månadsavgifter',
    tonWithdrawals: 'Integrerade TON-uttag',
    completeDashboard: 'Komplett dashboard',
    support247: 'Support dygnet runt',
    startNow: 'Börja nu',
  },
  faq: {
    title: 'Vanliga frågor',
    subtitle: 'Allt du behöver veta om Telegram Stars-betalningar',
    q1: 'Hur fungerar Telegram Stars-betalning?',
    a1: 'Telegram Stars-betalning gör det möjligt för handlare att acceptera betalningar direkt via Telegram. Användare skapar betalningslänkar, delar dem med kunder och tar emot betalningar i Telegram Stars-valutan.',
    q2: 'Vad är plattformsavgiften?',
    a2: 'Plattformsavgiften är 3 % per transaktion. Detta täcker betalningshantering, ledger-hantering och plattformsunderhåll. Det finns inga startavgifter eller månadskostnader.',
    q3: 'Hur tar jag ut mina Telegram Stars?',
    a3: 'Du kan begära uttag till din TON-plånbok. Uttag behandlas manuellt av säkerhetsskäl. Minsta uttag är 100 Stars.',
    q4: 'Är Telegram Stars-betalning säker?',
    a4: 'Ja, alla betalningar behandlas via Telegrams säkra betalningssystem. Vi använder branschstandard kryptering och säkerhetspraxis.',
    q5: 'Vad är Telegram Stars?',
    a5: 'Telegram Stars är en virtuell valuta som används inom Telegram för betalningar. Användare kan köpa Stars och använda dem för att betala tjänster, produkter och prenumerationer.',
    q6: 'Kan jag använda Telegram Stars-betalningar för mitt företag?',
    a6: 'Ja! Telegram Stars Payment Platform är utformad för handlare, kreatörer och företag. Du kan acceptera betalningar för digitala produkter, tjänster, prenumerationer och mer.',
  },
  cta: {
    title: 'Redo att komma igång?',
    subtitle: 'Gå med tusentals agenter som redan använder vår plattform',
    createAccount: 'Skapa gratis konto',
    signIn: 'Logga in',
  },
  footer: {
    description: 'Komplett SaaS-plattform för Telegram Stars-betalningar',
    product: 'Produkt',
    features: 'Funktioner',
    pricing: 'Priser',
    support: 'Support',
    signIn: 'Logga in',
    docs: 'Dokumentation',
    copyright: '© 2024 Telegram Stars Payment Platform. Alla rättigheter förbehållna.',
  },
  seo: {
    title: 'Telegram Stars Payment Platform | Acceptera betalningar via Telegram Stars',
    description: 'Acceptera betalningar via Telegram Stars. Skapa betalningslänkar direkt, hantera ditt saldo och ta ut till TON. 3 % plattformsavgift. Börja acceptera Telegram Stars-betalningar idag.',
    keywords: 'telegram stars betalning, acceptera telegram stars, telegram stars payment platform, telegram stars betalningsgateway',
  },
  whyPage: {
    seoTitle: 'Varför välja Telegram Stars Payment Platform | Fördelar',
    seoDescription: 'Upptäck varför handlare och kreatörer väljer Telegram Stars Payment Platform: omedelbar setup, transparenta priser, säkra betalningar och global räckvidd.',
    title: 'Varför välja oss?',
    subtitle: 'Byggd för handlare och kreatörer som vill ha enkla Telegram Stars-betalningar',
    r1Title: 'Omedelbar setup',
    r1Desc: 'Kom igång på några sekunder. Ingen komplex konfiguration eller teknisk kunskap krävs.',
    r2Title: 'Transparenta priser',
    r2Desc: 'Endast 3 % per transaktion. Inga dolda avgifter, inga månadskostnader, inga startavgifter.',
    r3Title: 'Säker och pålitlig',
    r3Desc: 'Byggd på Telegrams säkra betalningsinfrastruktur med branschstandard kryptering.',
    r4Title: 'Global räckvidd',
    r4Desc: 'Acceptera betalningar från Telegram-användare världen över. Inga geografiska begränsningar.',
    r5Title: 'Enkel integration',
    r5Desc: 'Enkel API och webhooks. Integrera med dina befintliga system på några minuter.',
    r6Title: 'TON-uttag',
    r6Desc: 'Ta ut direkt till din TON-plånbok. Snabba och säkra uttag.',
  },
  howPage: {
    seoTitle: 'Så fungerar det | Telegram Stars Payment Platform',
    seoDescription: 'Lär dig hur du accepterar betalningar via Telegram Stars i 3 enkla steg. Skapa ditt konto, generera betalningslänkar och ta ut till TON.',
    title: 'Så fungerar det',
    subtitle: 'Acceptera Telegram Stars-betalningar i tre enkla steg',
  },
  settings: {
    title: "Inställningar",
    languageSection: "Språk",
    defaultLanguage: "Standardspråk",
    languageHint: "Detta språk gäller för hela plattformen (landningssidor och gränssnitt).",
    languageSaved: "Språk uppdaterat",
    ...settingsApp,
  },
  app,
};

export default sv;
